import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../baseQuery';
import {
  QueryParamsTaxesType,
  ResponseGetTaxesType,
  TabsTaxesTypes,
  TabTaxeResponseType,
  TaxesItemsTypes,
} from './type';

export const taxesApi = createApi({
  reducerPath: 'taxesApi',
  tagTypes: ['Taxes', 'Taxe', 'Tabs', 'Tab'],
  refetchOnReconnect: true,
  keepUnusedDataFor: 15,
  baseQuery: baseQueryWithReauth(),
  endpoints: (build) => ({
    getTaxes: build.query<ResponseGetTaxesType, QueryParamsTaxesType>({
      query: ({ page, per_page, tax_period, search }) => ({
        url: '/taxes',
        method: 'GET',
        params: { page, per_page, tax_period, search },
      }),
      providesTags: () => ['Taxes'],
    }),
    getTaxe: build.query<TaxesItemsTypes, { id: string }>({
      query: ({ id }) => {
        const token = localStorage.getItem('token');
        const Authorization = token ? `Bearer ${token}` : undefined;
        return {
          url: `/taxes/tax-rolls/${id}`,
          method: 'GET',
          headers: {
            Accept: 'application/json',
            Authorization,
          },
        };
      },
      providesTags: () => ['Taxe'],
    }),
    getTabs: build.query<TabsTaxesTypes, { id: string }>({
      query: ({ id }) => {
        const token = localStorage.getItem('token');
        const Authorization = token ? `Bearer ${token}` : undefined;
        return {
          url: `/taxes/tax-rolls/${id}/tabs`,
          method: 'GET',
          headers: {
            Accept: 'application/json',
            Authorization,
          },
        };
      },
      providesTags: () => ['Tabs'],
    }),
    getTabTaxe: build.query<TabTaxeResponseType, { title?: string; id?: string }>({
      query: ({ title, id }) => {
        const token = localStorage.getItem('token');
        const Authorization = token ? `Bearer ${token}` : undefined;
        return {
          url: `/taxes/tax-rolls/${id}/tabs/${title}`,
          method: 'GET',
          headers: {
            Accept: 'application/json',
            Authorization,
          },
        };
      },
      providesTags: () => ['Tab'],
    }),
  }),
});

export const { useGetTaxesQuery, useGetTabsQuery, useGetTaxeQuery, useGetTabTaxeQuery } =
  taxesApi;
